<template>
  <footer class="page-footer">
    <div class="d-flex all-footer-container justify-content-between mx-2">
      <div class="edge-spacing d-flex gap-4 icons-footer-style">
        <a
          href="https://www.linkedin.com/company/gfu-cyrus-ag/mycompany/"
          target="_blank"
        >
          <font-awesome-icon icon="fa-brands fa-linkedin-in" />
        </a>
        <a href="https://www.instagram.com/gfucyrusag/" target="_blank">
          <font-awesome-icon icon="fa-brands fa-instagram" />
        </a>
        <a href="https://www.facebook.com/GFU.net" target="_blank">
          <font-awesome-icon icon="fa-brands fa-facebook-f" />
        </a>
      </div>
      <div class="text-center mt-3 edge-spacing">
        © {{ currentYear }} GFU Cyrus AG. All rights reserved.
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  },
};
</script>
